/* @jsx jsx */
import { jsx, Flex, Link } from 'theme-ui'
import React from 'react'
import PartialStar from './PartialStar'
import Text from '~/components/IntlComponents/Text'
import FullStarIcon from '~/assets/images/icons/full-star.svg'
import EmptyStarIcon from '~/assets/images/icons/empty-star.svg'
import { experiments, useExperiment } from '~/hooks/utils/use-experiment'

const Reviews = ({
  averageScore,
  totalReviews,
  showReadReviews,
  showTotalReviews,
  color,
  totalStars,
}) => {
  const starsArray = Array.from({ length: totalStars }, (_, index) => {
    if (index + 1 <= averageScore)
      return (
        <FullStarIcon
          sx={{ path: { fill: color, stroke: color } }}
          key={index + 'star'}
        />
      )
    if (averageScore % 1 !== 0)
      return (
        <PartialStar
          color={color}
          decimal={(averageScore % 1).toFixed(1)}
          key={index + 'star'}
        />
      )
    if (index + 1 > averageScore)
      return (
        <EmptyStarIcon sx={{ path: { stroke: color } }} key={index + 'star'} />
      )
  })

  const collectionsCardsTest = useExperiment(experiments.newProductCardLayout)

  //const displayText = collectionsCardsTest ? `(${totalReviews})` : `${totalReviews} reviews`
  const displayText = `(${totalReviews})`

  return (
    <>
      <Flex
        sx={{
          alignItems: 'center',
          /*gap: collectionsCardsTest ? ['4px'] : '0.625rem',*/
          gap: ['4px'],
        }}
      >
        <Flex sx={{ gap: ['0', '0.5rem'] }}>{starsArray}</Flex>
        <Text
          as="span"
          sx={{
            fontFamily: 'secondary',
            fontWeight: 'regular',
            lineHeight: 0.88,
          }}
        >
          {averageScore.toFixed(1)}
        </Text>
      </Flex>
      {showReadReviews && (
        <Link
          href="#review-widget"
          sx={{
            borderBottom: '2px solid',
            textTransform: 'uppercase',
            fontFamily: 'secondary',
            fontSize: '0.875rem',
          }}
        >
          {totalReviews} Reviews
        </Link>
      )}
      {showTotalReviews && (
        <Text
          as="span"
          sx={{
            fontFamily: 'secondary',
            fontWeight: 'regular',
            lineHeight: 0.88,
          }}
        >
          {displayText}
        </Text>
      )}
    </>
  )
}

export default Reviews
